import { render, staticRenderFns } from "./form_knowledge.vue?vue&type=template&id=0a96c2e7&scoped=true"
import script from "./form_knowledge.vue?vue&type=script&lang=js"
export * from "./form_knowledge.vue?vue&type=script&lang=js"
import style0 from "./form_knowledge.vue?vue&type=style&index=0&id=0a96c2e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96c2e7",
  null
  
)

export default component.exports